import React, { useRef, useEffect } from "react";
import { Rect, Transformer } from "react-konva";

const PopupTriggerRect = ({
  shapeProps,
  x,
  y,
  width,
  height,
  selected,
  draggable,
  handleMouseDown,
  handleDragMove,
  id,
  trigger,
  triggers,
  setTriggers,
  canvasWidth,
  canvasHeight,
  handleClick,
  updateSize,
  minScale,
  dash,
  colorPickerVisible,
}) => {
  const shapeRef = useRef();
  const trRef = useRef();

  useEffect(() => {
    if (selected) {
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [selected]);

  const handleDragEnd = (draggedTrigger) => {
    // check whether the rect's coordinates are outside the canvas
    // first x-axis, then y-axis

    setTriggers(
      triggers.map((trigger) => {
        if (trigger.id === draggedTrigger.id) {
          return {
            ...trigger,
            x: draggedTrigger.x,
            y: draggedTrigger.y,
          };
        } else return trigger;
      })
    );
  };

  return (
    <>
      <Rect
        ref={shapeRef}
        name={"rect"}
        {...shapeProps}
        draggable={draggable}
        x={x}
        y={y}
        width={width}
        height={height}
        fill={"#00D14A"}
        opacity={0.3}
        stroke={trigger.fill}
        strokeWidth={1}
        dash={dash}
        onClick={handleClick}
        selected={selected}
        id={id}
        onDragEnd={(e) => handleDragEnd(trigger)}
        onMouseDown={handleMouseDown}
        onDragMove={handleDragMove}
        onTransformEnd={() => {
          const node = shapeRef.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();

          node.scaleX(1);
          node.scaleY(1);
          updateSize(trigger.id, {
            x: node.x(),
            y: node.y(),
            width: node.width() * scaleX,
            height: node.height() * scaleY,
          });
        }}
      />
      {selected && (
        <Transformer
          ref={trRef}
          keepRatio={false}
          rotateEnabled={false}
          borderStrokeWidth={colorPickerVisible ? 0 : 1}
          borderDash={[4, 3]}
          boundBoxFunc={(oldBox, newBox) => {
            // limit resize
            if (newBox.width < minScale || newBox.height < minScale) {
              return oldBox;
            }
            return newBox;
          }}
        />
      )}
    </>
  );
};

export default PopupTriggerRect;
